// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal__Modal__32_-a"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/Modal.css
// module id = 79
// module chunks = 16